import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireLib } from '../node_modules/@hypnosphi/create-react-context/lib/index.js';

var libExports = requireLib();
var createContext = /*@__PURE__*/getDefaultExportFromCjs(libExports);

export { createContext as default };
